import React from 'react';
import ProductInterface from '../ProductInterface';
import MonhrlyOptions from './MonhrlyOptions';
import { processMonhrly } from './monhrlyProcess';

export default function Monhrly() {
  return (
      <ProductInterface
          product = "monhrly"
          ProductOptions = {MonhrlyOptions}
          processProduct = {processMonhrly}
      />
  )
} 